import '@mdi/font/css/materialdesignicons.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import Vue from 'vue';
import Vuetify, { VTextField } from 'vuetify/lib';

import { settings } from '@/config';
import { i18n } from '@/i18n';
import locales from '@/i18n/vuetify';
import themes from './vuetifyThemes';

Vue.use(Vuetify);

const defaultDateTimeFormat = {
  short: {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  },
  long: {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    weekday: 'long',
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
  },
};

const dateTimeFormats = {
  'en-US': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
  'et-EE': defaultDateTimeFormat,
  'rus-RU': defaultDateTimeFormat,
};

export const options = {
  theme: {
    options: {
      customProperties: true,
    },
    dark: false,
    themes: themes[0],
  },
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    locales,
    current: settings.locale,
    t: (key, ...params) => i18n.t(key, params),
  },
  dateTimeFormats,
  components: {
    VTextField,
  },
  breakpoint: {
    mobileBreakpoint: 711,
  },
};

const vuetify = new Vuetify(options);

export default vuetify;
